module.exports = __webpack_public_path__ + "static/media/Mrs Scratchen-Post.c00e7a8c.jpg";